<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="desserts"
      height="70vh"
      :items-per-page="-1"
      :search="search"
      :fixed-header="true"
      class="elevation-3"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Cadastro de Assessor</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-flex xs2>
            <v-select
              class="pa-2 mt-10"
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="selects.candidatos.ativado"
              @change="getMetas(select_equipe), getAssessor(select_equipe)"
              outlined
              label="Equipe"
              dense
              height="10"
              item-value="idcandidato"
              item-text="nome_completo"
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-select
              v-model="select_meta"
              class="pa-2 mt-10"
              :items="selects.metas.items"
              outlined
              label="Tipo de Meta"
              dense
              height="10"
              item-value="idmeta"
              item-text="descricao"
            ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog persistent v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                rounded
                color="primary"
                dark
                class="mb-2"
                @click="setEquipe()"
                v-on="on"
                >Novo</v-btn
              >

              <v-btn
                color="warning"
                small
                rounded
                title="Relatório Assessor"
                style="margin-right: 15px"
                @click="RelatorioAssessor(select_equipe, select_meta)"
              >
                <v-icon> mdi-tray-full </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.name"
                        counter
                        label="Nome Completo*"
                        :error-messages="nameErrors"
                        @input="$v.editedItem.name.$touch()"
                        @blur="$v.editedItem.name.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.email"
                        label="Email*"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email.$touch()"
                        @blur="$v.editedItem.email.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.idperfil"
                        :items="selects.perfil.items"
                        @change="clearMeta(editedItem.idperfil)"
                        chips
                        label="Perfil do Sistema"
                        height="10"
                        outlined
                        item-value="idperfil"
                        item-text="descricao_perfil"
                        style="margin-right: 5px"
                        :error-messages="perfilErrors"
                        @input="$v.editedItem.idperfil.$touch()"
                        @blur="$v.editedItem.idperfil.$touch()"
                      ></v-select>
                    </v-col>
                    <v-col class="pa-0" cols="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.telefone"
                        label="Telefone*"
                        style="margin-left: 5px"
                        :error-messages="setorErrors"
                        v-mask="'(##) #####-####'"
                        @input="$v.editedItem.telefone.$touch()"
                        @blur="$v.editedItem.telefone.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedIndex === -1"
                      class="pa-0"
                      cols="6"
                      xs="6"
                    >
                      <v-text-field
                        outlined
                        v-model="editedItem.password"
                        label="Nova Senha*"
                        style="margin-right: 5px"
                        :error-messages="passwordErrors"
                        type="password"
                        autocomplete="new-password"
                        @input="$v.editedItem.password.$touch()"
                        @blur="$v.editedItem.password.$touch()"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedIndex === -1"
                      class="pa-0"
                      cols="6"
                      xs="6"
                    >
                      <v-text-field
                        style="margin-left: 5px"
                        outlined
                        v-model="editedItem.repeatPassword"
                        label="Confirma Senha*"
                        :error-messages="repeatPasswordErrors"
                        type="password"
                        @input="$v.editedItem.repeatPassword.$touch()"
                        @blur="$v.editedItem.repeatPassword.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      v-show="editedItem.idperfil != 4"
                      class="pa-0"
                      cols="6"
                      xs="6"
                    >
                      <v-select
                        v-model="editedItem.idgerente"
                        :items="selects.candidatos.items"
                        :disabled="selects.candidatos.ativado"
                        style="margin: 0px 5px 0px 0px"
                        chips
                        label="Equipe"
                        height="10"
                        outlined
                        item-value="idcandidato"
                        item-text="nome_completo"
                        :error-messages="gerenteErrors"
                        @change="getMetas(editedItem.idgerente)"
                        @input="$v.editedItem.idgerente.$touch()"
                        @blur="$v.editedItem.idgerente.$touch()"
                      ></v-select>
                    </v-col>

                    <v-col
                      v-show="editedItem.idperfil != 4"
                      class="pa-0"
                      cols="6"
                      xs="6"
                    >
                      <v-select
                        style="margin-left: 5px"
                        v-model="editedItem.idmeta"
                        :items="selects.metas.items"
                        chips
                        label="Meta"
                        height="10"
                        outlined
                        item-value="idmeta"
                        item-text="descricao"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="pa-0">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Usuário" class="mr-2" @click="editItem(item)"
          >mdi-pencil</v-icon
        >
        <v-icon title="Remover Usuário" class="mr-2" @click="deleteItem(item)"
          >mdi-delete</v-icon
        >

        <v-icon
          color="warning"
          title="Refresh  de senha"
          @click="refreshPassword(item)"
          >mdi-lock-open</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import UsuarioAPI from "./../../api/usuario";
import AclAPI from "./../../api/acl";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Nome Completo",
        align: "left",
        value: "name",
      },
      { text: "Email", value: "email" },
      { text: "Telefone", value: "telefone" },
      { text: "Perfil", value: "descricao_perfil" },
      { text: "Equipe", value: "idgerente" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    select_equipe: 0,
    select_meta: 0,
    selects: {
      perfil: {
        items: [],
      },
      candidatos: {
        ativado: false,
        items: [],
      },
      metas: {
        items: [],
      },
    },
    editedItem: {
      id: "",
      name: "",
      email: "",
      telefone: "",
      idperfil: "",
      password: "",
      repeatPassword: "",
      idgerente: "",
      idmeta: "",
    },
    defaultItem: {
      id: "",
      name: "",
      email: "",
      telefone: "",
      idperfil: "",
      password: "",
      repeatPassword: "",
      idgerente: "",
      idmeta: "",
    },
  }),

  validations: {
    editedItem: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        required,
        email,
      },
      telefone: {
        required,
      },
      idperfil: {
        required,
      },
      password: {
        required,
        minLength: minLength(4),
      },
      idgerente: {
        required,
      },
      repeatPassword: {
        sameAsPassword: sameAs("password"),
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.name.$dirty) return errors;
      !this.$v.editedItem.name.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.name.minLength &&
        errors.push("A Nome Completo  dever ser maior que 4 caracteres");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      !this.$v.editedItem.email.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    setorErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    perfilErrors() {
      const errors = [];
      if (!this.$v.editedItem.idperfil.$dirty) return errors;
      !this.$v.editedItem.idperfil.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    gerenteErrors() {
      const errors = [];
      if (!this.$v.editedItem.idgerente.$dirty) return errors;
      !this.$v.editedItem.idgerente.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.editedItem.password.$dirty) return errors;
      !this.$v.editedItem.password.minLength &&
        errors.push("A senha dever ser maior que 4 caracteres");
      !this.$v.editedItem.password.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.editedItem.repeatPassword.$dirty) return errors;
      !this.$v.editedItem.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Novo Assessor" : "Editar Assessor";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const headers = this.Helpers.iniciarRequisicao();
      //Filtro Usuarios da Equipe caso tenha
      const equipe = localStorage.getItem("equipe");

      const params = {
        equipe: equipe,
        assessor: 1,
      };

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      }

      UsuarioAPI.getPerfis(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.perfil.items = response.data.perfis;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });

      this.$store.dispatch(
        "loading/addRequisicao",

        UsuarioAPI.getUsuarios(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.usuarios;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getAssessor(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
        assessor: 1,
      };

      this.$store.dispatch(
        "loading/addRequisicao",

        UsuarioAPI.getUsuarios(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.usuarios;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.getMetas(this.editedItem.idgerente);
      this.dialog = true;
    },

    refreshPassword(item) {
      if (
        confirm("Deseja redefinir a senha do Candidato? Senha Padrão: 123456")
      ) {
        this.editedItem = Object.assign({}, item);

        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.resetPassword(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover usuário?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.deletar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação registro possui vínculos!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    clearMeta(id) {
      if (id == 4) {
        this.editedItem.idmeta = null;
      }
    },

    save() {
      if (this.editedItem.id > 0) {
        this.editedItem.repeatPassword = this.editedItem.password;
      }

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.salvar(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );

        this.close();
      }
    },
    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.editedItem.idgerente = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      }
    },
    RelatorioAssessor(equipe, meta) {
      let url =
        "relatorio_analitico_assessores?equipe=" + equipe + "&meta=" + meta;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
  },
};
</script>
<style scoped>
</style>